import { VALID_RESULT } from 'common/constants'
import { isString } from 'common/helpers'
import type { ValidationResult } from 'common/types'

export const validateName = (value: unknown): ValidationResult =>
  isString(value) && value.trim().length > 0
    ? VALID_RESULT
    : { isValid: false, errText: 'Название не может быть пустым' }
